import React from 'react';
import { Link } from 'react-router-dom';

/**
 * Mirevy Logo — vertical stacked mark.
 *
 *   [ lotus icon ]
 *      MIREVY
 *
 * The lotus is extracted from the original brand logo (transparent PNG) and
 * the wordmark is rendered in Playfair Display so it stays crisp at every
 * size and matches the rest of the site typography.
 */
const Logo = ({ className = '', size = 'default', linkTo = '/' }) => {
  const sizes = {
    small:   { icon: 28, label: 'text-[10px] tracking-[0.32em]', gap: 'mt-1' },   // Footer
    default: { icon: 36, label: 'text-[11px] tracking-[0.34em]', gap: 'mt-1' },   // Header
    large:   { icon: 64, label: 'text-base tracking-[0.4em]',    gap: 'mt-1.5' }, // Hero
  };
  const cfg = sizes[size] || sizes.default;

  const mark = (
    <span className={`inline-flex flex-col items-center leading-none select-none pb-1 ${className}`}>
      <img
        src="/lotus.png"
        alt=""
        aria-hidden="true"
        height={cfg.icon}
        style={{ height: `${cfg.icon}px`, width: 'auto' }}
        className="block"
      />
      <span
        className={`${cfg.gap} font-serif font-medium text-brand-gold-dark ${cfg.label}`}
      >
        MIREVY
      </span>
    </span>
  );

  if (linkTo) {
    return (
      <Link
        to={linkTo}
        aria-label="Mirevy — Home"
        className="inline-flex items-center hover:opacity-90 transition-opacity focus:outline-none focus:ring-2 focus:ring-brand-gold focus:ring-offset-2 rounded-lg"
      >
        {mark}
      </Link>
    );
  }

  return mark;
};

export default Logo;
